import Vue from 'vue';
import i18n from './../../shared/i18n';
import EventBus from "../event-bus";
import {ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE, ON_CONFIRM_WITH_COMMENT_DIALOG_OPEN} from "../event-bus/event-bus-names";

const ConfirmWithCommentModal = {
  install(Vue) {
    Vue.prototype.$confirmWithComment = (
      message,
      title = i18n.t('Please Confirm'),
      submitBtnText = i18n.t('Yes'),
      cancelBtnText = i18n.t('No'),
      commentLabel = i18n.t('Comment'),
      commentRules = 'required|min:3|max:1024',
      variant = null,
    ) => {
      return new Promise((resolve) => {
        EventBus.$emit(ON_CONFIRM_WITH_COMMENT_DIALOG_OPEN, {message, title, submitBtnText, cancelBtnText, commentLabel, commentRules, variant});
        EventBus.$off(ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE);
        EventBus.$on(ON_CONFIRM_WITH_COMMENT_DIALOG_HIDE, (payload) => {
          resolve(payload);
        })
      });
    }
  }
};

Vue.use(ConfirmWithCommentModal);
